import {
    Auth0UserSettings,
} from '../../Store/User';

import { Auth0ContextInterface, IdToken } from '@auth0/auth0-react';
import { CombinePathComponents } from '../../Utils/PathUtils';
import { LogException } from '../../Utils/Logging';

export type Auth0UserInformationResult = {
    token: string;
    idTokenClaims?: IdToken;
    idpUserProperties: { [key: string]: string };
}

export async function GetAuth0UserInformation(
    auth0Methods:Auth0ContextInterface,
    auth0Config: Auth0UserSettings,
): Promise<Auth0UserInformationResult> {
    const token = await auth0Methods.getAccessTokenSilently(
        {
            audience: auth0Config.audience,
            scope: auth0Config.scope,
        }
    );

    const idTokenClaims = await auth0Methods.getIdTokenClaims();
    let idpUserProperties: { [key: string]: string } = {}

    if (!!(idTokenClaims?.sub)) {
        try {
            const userInfoFetchUrl = CombinePathComponents(`https://${auth0Config.domain}`, 'api/v2/users', encodeURIComponent(idTokenClaims!.sub));

            const userInfo = await fetch(userInfoFetchUrl,
                {
                    mode: 'cors',
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            idpUserProperties = await userInfo.json();
        } catch (idpPropsFailure) {
            LogException(
                `Failed during postlogin processing, unable to get logged in user properties from identity provider`,
                idpPropsFailure
            );

            console.error(idpPropsFailure);

            throw idpPropsFailure;
        }
    }

    return {
        token,
        idTokenClaims, 
        idpUserProperties,
    };
}
